module.exports = __webpack_public_path__ + "img/mouth_female_thin_mask.80d62d46.png";